import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import AgentCreation from './AgentCreation';
import Ivr from './Ivr';
import Workflow from './WorkFlow';
import Header from '../../common/Header';
import Sidebar from '../../common/Sidebar';
import PageHeader from '../PageHeader';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { IconButton, Paper, Chip, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
export default function CallingoAgents() {
    const navigate = useNavigate();
    const location = useLocation();
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const agentid = obj["agentid"];
    const ivrid = obj["ivrid"];
    const workflowid = obj["workflowid"];
    const flowid = obj["flowid"];
    const iscreate = obj["iscreate"];
    const name = obj["name"];
    const type = obj["type"];
    const isupdate = obj["isupdate"];
    const mainHeading = isupdate !== "false" ? "Agent Update" : "Agent Creation";
    const heading = `Agents / ${mainHeading}`;



    const [currentStep, setCurrentStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    // Main navigation steps matching the image design
    const steps = [
        { id: 0, key: "agent", label: "Agents", icon: "bi-robot", path: "/agentscreation" },
        { id: 1, key: "ivr", label: "IVR", icon: "bi-telephone-inbound", path: "/agentscreation/ivr" },
        { id: 2, key: "workflow", label: "Workflow", icon: "bi-diagram-3", path: "/agentscreation/workflow" },
    ];


    // Function to move to next step (can be called from child components)
    const goToNextStep = (data) => {
        if (type === 'in-bound') {
            setValue(value + 1);
        } else {
            navigate('/agentslist');
        }

    };

    // Function to go to previous step
    const goToPreviousStep = () => {
        setValue(value - 1);
    };
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`full-width-tabpanel-${index}`}
                aria-labelledby={`full-width-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ pt: 1 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }
    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [showtabs, setShowtabs] = useState(false);

    useEffect(() => {
        if (type === 'in-bound') {
            if (isupdate) {
                setShowtabs(true);
            } else if (iscreate) {
                setShowtabs(true);
            }
        }


    }, []);

   

   


    return (
        <div id="layout-wrapper">
            <Header />
            <Sidebar />

            <div className="page-content">
                <div className="main-content">
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <IconButton onClick={() => navigate('/configurations/agentconfigurations')}>
                                <ArrowBack />
                            </IconButton>
                            <Box>
                                <Typography variant="h5" fontWeight={600}>
                                    {name}
                                </Typography>
                                {/* <Typography variant="body2" color="text.secondary">
                                    {isupdate ? 'Update Agent' : 'Create Agent'}
                                </Typography> */}
                            </Box>
                        </Box>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">Agents List</li>
                                <li className="breadcrumb-item active">{isupdate ? 'Update Agent' : 'Create Agent'}</li>
                                {/* <li className="breadcrumb-item active">{heading.split('/')[2]}</li> */}
                            </ol>
                        </div>
                    </Box>

                    {/* ================= SPLIT LAYOUT ================= */}
                    <Box sx={{ display: 'flex', gap: 2 }}>

                        {/* ========== LEFT MAIN MENU ========== */}
                        {type !== 'out-bound' && (
                            <Paper
                                elevation={0}
                                sx={{
                                    width: 220,
                                    borderRadius: 3,
                                    border: '1px solid #e5e7eb',
                                    p: 1,
                                    minHeight: '70vh',
                                }}
                            >
                                <Typography
                                    sx={{
                                        px: 2,
                                        py: 1,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: 'text.secondary',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Configuration
                                </Typography>

                                {steps.map((step, index) => (
                                    <Box
                                        key={step.id}
                                        onClick={() =>
                                            !(iscreate && index !== 0) && setValue(index)
                                        }
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            px: 2,
                                            py: 1.5,
                                            borderRadius: 2,
                                            cursor:
                                                iscreate && index !== 0
                                                    ? 'not-allowed'
                                                    : 'pointer',
                                            backgroundColor:
                                                value === index ? '#e3f2fd' : 'transparent',
                                            color:
                                                value === index ? '#1976D2' : '#374151',
                                            opacity:
                                                iscreate && index !== 0 ? 0.5 : 1,
                                            '&:hover': {
                                                backgroundColor:
                                                    value === index
                                                        ? '#e3f2fd'
                                                        : '#f8fafc',
                                            },
                                        }}
                                    >
                                        <Chip
                                            label={index + 1}
                                            size="small"
                                            sx={{
                                                bgcolor:
                                                    value >= index ? '#014670' : '#adb5bd',
                                                color: '#fff',
                                                fontWeight: 600,
                                            }}
                                        />
                                        <i className={`bi ${step.icon}`} />
                                        <Typography fontSize={14}>
                                            {step.label}
                                        </Typography>
                                    </Box>
                                ))}

                                       {/* Progress Indicator */}
                                <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e5e7eb' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography fontSize={12} fontWeight={600} color="#64748b">
                                            Progress
                                        </Typography>
                                        <Typography fontSize={12} fontWeight={700} color="#74bf23">
                                            {Math.round(((value + 1) / steps.length) * 100)}%
                                        </Typography>
                                    </Box>
                                    <Box 
                                        sx={{ 
                                            height: 8, 
                                            bgcolor: '#e5e7eb', 
                                            borderRadius: 1,
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Box 
                                            sx={{ 
                                                height: '100%', 
                                                bgcolor: '#74bf23',
                                                width: `${((value + 1) / steps.length) * 100}%`,
                                                transition: 'width 0.3s ease',
                                                borderRadius: 1
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Paper>
                        )}

                        {/* ========== RIGHT CONTENT AREA ========== */}
                        <Box sx={{ flex: 1, minHeight: '70vh', }}>
                            <TabPanel value={value} index={0}>
                                <AgentCreation
                                    agentName={name}
                                    agentType={type}
                                    flowID={flowid}
                                    agentid={agentid}
                                    goToNextStep={goToNextStep}
                                />
                            </TabPanel>

                            {type === 'in-bound' && (
                                <TabPanel value={value} index={1}>
                                    <Ivr
                                        flowID={flowid}
                                        ivrid={ivrid}
                                        agentType={type}
                                        goToNextStep={goToNextStep}
                                        goToPreviousStep={goToPreviousStep}
                                    />
                                </TabPanel>
                            )}

                            {type === 'in-bound' && (
                                <TabPanel value={value} index={2}>
                                    <Workflow
                                        flowID={flowid}
                                        workflowid={workflowid}
                                        agentType={type}
                                        goToNextStep={goToNextStep}
                                        goToPreviousStep={goToPreviousStep}
                                    />
                                </TabPanel>
                            )}
                        </Box>

                    </Box>
                </div>
            </div>
        </div>
    );

}
